import { PropsWithChildren } from 'react'

type RootProps = {}

export const Root = ({ children }: PropsWithChildren<RootProps>) => {
  return <div className="p-4 flex gap-6">{children}</div>
}
